import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const data = [
    { centre: "Vizag", utilization: 76 },
    { centre: "Vijayawada", utilization: 68 },
    { centre: "Tirupati", utilization: 64 },
    { centre: "Kurnool", utilization: 52 },
];

export default function UtilizationChart() {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                margin={{ top: 25, right: 20, left: 0, bottom: 10 }}
                barCategoryGap="30%"
            >
                <CartesianGrid
                    strokeDasharray="4 4"
                    stroke="#EEF1F5"
                    vertical={false}
                />

                <XAxis
                    dataKey="centre"
                    tick={{ fontSize: 13, fill: "#94A3B8" }}
                    axisLine={false}
                    tickLine={false}
                    dy={10}
                />

                <YAxis
                    tick={{ fontSize: 13, fill: "#94A3B8" }}
                    axisLine={false}
                    tickLine={false}
                />

                <Tooltip
                    cursor={{ fill: "#F1F5F9" }}
                    formatter={(value) => [`${value}%`, "Utilization"]}
                    contentStyle={{
                        borderRadius: 12,
                        border: "1px solid #E5E7EB",
                        boxShadow: "0 8px 20px rgba(15,23,42,0.08)",
                        fontSize: 13,
                    }}
                />

                <Bar
                    dataKey="utilization"
                    fill="#2563EB"
                    radius={[10, 10, 0, 0]}
                    maxBarSize={70}
                />
            </BarChart>
        </ResponsiveContainer>
    );
}